import React from 'react';
import { BrowserRouter, Routes, Route, NavLink, Navigate, Link } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import LandingPage from './pages/LandingPage';
import { LoginPage, RegisterPage } from './pages/AuthPages';
import ProfilePage from './pages/ProfilePage';
import PartnerPage from './pages/PartnerPage';
import OfferPage from './pages/OfferPage';
import SupportWidget from './components/SupportWidget';
import './index.css';

function Layout({ children }: { children: React.ReactNode }) {
  const { userAuth } = useApp();

  return (
    <div className="app">
      <nav className="nav">
        <div className="nav-brand">
          <span className="brand-dot" />
          <span className="brand-name">daotta</span>
        </div>
        <div className="nav-links">
          <NavLink to="/" end className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            Кабинет
          </NavLink>
          <NavLink to="/profile" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            Профиль
          </NavLink>
          {userAuth.token && (
            <button type="button" className="nav-link nav-logout" onClick={userAuth.logout}>
              Выйти
            </button>
          )}
        </div>
      </nav>
      <main className="main">{children}</main>
      <footer className="site-footer">
        <span>
          Техническая интеграция платежной инфраструктуры осуществляется через Bitbanker KG на основании оферты:
        </span>
        <Link to="/offer">
          публичная оферта Bitbanker KG
        </Link>
      </footer>
      <SupportWidget />
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/admin/*" element={<Navigate to="/" replace />} />
            <Route path="/partner" element={<PartnerPage />} />
            <Route path="/offer" element={<OfferPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AppProvider>
  );
}
